<template>
    <HomeLayout :isShowDelivery="false" customClass="">
        <div class="max-w-sm m-auto p-4">
            <div class="font-bold text-center text-18 text-a-brown-502314 py-4">{{lbl.earnpoint.title}}</div>
            <div class="bg-image-white bg-white py-5 rounded-20 border border-a-brown-e1d2bc">
                <EarnPointLevel></EarnPointLevel>
                <EarnPointQR></EarnPointQR>
            </div>
            <div class="text-center text-14 text-a-brown-502314 py-4">{{lbl.earnpoint.your_point_update}}</div>
            <div class="max-w-255px m-auto">
                <RedButton @click="openHistory()">{{lbl.earnpoint.point_history}}</RedButton>
            </div>
            <Benefit></Benefit>
        </div>

        <DownloadApp></DownloadApp>
    </HomeLayout>
</template>

<script>
import Util from '@/helper/Utility.js';
//component
import HomeLayout from '@/components/Layout/Page/HomeLayout.vue'
import EarnPointLevel from '../component/EarnPointLevel.vue'
import EarnPointQR from '../component/EarnPointQR.vue'
import RedButton from '@/components/Button/RedButton.vue'
import Benefit from '../component/Benefit.vue';
import DownloadApp from '@/module/Home/component/DownloadApp.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "EarnPoint",
    mixins: [AuthStatusMixin,LocaleMixin],
    components: {
        HomeLayout,
        EarnPointLevel,
        EarnPointQR,
        RedButton,
        Benefit,
        DownloadApp,
    },
    created() {
        this.tracking.screenName('qr_earn_point');
        this.tracking.event('qr_earn_point','view_qr_earn_point',null,null);
    },
    mounted: function () {
        Util.scrollTop();
    },
    methods: {
        //AuthStatusMixin
        onAccountInit: function () {
            if (this.isLoginGuest) {
                let path = this.$route.path;
                this.$router.push({
                    name: 'login',
                    query: {
                        afterLogin: path,
                    }
                });
            }
        },

        openHistory: function () {
            this.tracking.event('qr_earn_point','click_point_history');
            this.$router.push('/history');
        },
    },
}
</script>
<style>
    .bg-image-white {
        background-image: url('../../../assets/bg/bg-white-burger.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
    }
</style>
